var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c(_vm.key,{tag:"component",attrs:{"pallet":_vm.pallet,"disabledDescription":"このオブジェクトは変更できません。"},model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }